module.exports = __webpack_public_path__ + "static/media/videoUserManual.36d22b96.png";